export const UTM_LOCAL_STORAGE_KEY = 'utm-params';
